import BaseEntity from '../../base/BaseEntity.model';
import TramiteCambioDireccion from '../cambio-direccion/cambio-direccion.model';
import SolicitudCambioComposicionFamiliar from '../solicitud-cambio-composicion-familiar';
import TramiteCambioJefeHogar from '../cambio-jefe-hogar/cambioJefeHogar.model';

export default class SolicitudCasoExtrairdinarioModel extends BaseEntity {
    public tramiteBeneficiarioId?: number;
    public titularApodo?: string;
    public titularTelefono?: string;
    public titularCelular?: string;
    public titularEmail?: string;
    public titularNoHabitante?: string;
    public solicitanteEsTitular?: boolean;
    public titularDisponible?: boolean;
    public generaCambioDireccion?: boolean;
    public generaCambioComposicionFamiliar?: boolean;
    public generaCambioJefeHogar?: boolean;
    public razonTitularNoDisponibleId?: number;
    public quienUtilizaTarjeta? : string;
    public cedulaQuienUtilizaTarjeta? : string;
    public tramiteCambioDireccion?: TramiteCambioDireccion;
    public solicitudCambioComposicionFamiliar?: SolicitudCambioComposicionFamiliar;
    public tramiteCambioJefeHogar?: TramiteCambioJefeHogar;


    public tipoTramiteCambioJefeCode?: string;
    public razonCambioJefeDesc?: string;

    public codigoTipoTramite?: string;
    public tituloTipoTramite?: string;
    public tipoTramiteId?: number;
    constructor() {
        super();
        this.tramiteBeneficiarioId = undefined;
        this.titularApodo = undefined;
        this.titularTelefono = undefined;
        this.titularCelular = undefined;
        this.titularEmail = undefined;
        this.titularNoHabitante = undefined;
        this.solicitanteEsTitular = true;
        this.titularDisponible = undefined;
        this.generaCambioDireccion = undefined;
        this.generaCambioJefeHogar = undefined;
        this.generaCambioComposicionFamiliar = undefined;
        this.razonTitularNoDisponibleId = undefined;
        this.quienUtilizaTarjeta = undefined;
        this.cedulaQuienUtilizaTarjeta = undefined;
        this.tramiteCambioDireccion = undefined;
        this.solicitudCambioComposicionFamiliar = undefined;
        this.tipoTramiteCambioJefeCode = undefined;
        this.razonCambioJefeDesc = undefined;
    }
}